import React, { FunctionComponent } from 'react';

type Props = {
  flash: boolean;
  flashType: string;
  flashMessage: string;
  handleClose: () => void;
};

export const Presentation: FunctionComponent<Props> = ({ flash, flashType, flashMessage, handleClose }) => {
  const icon = (() => {
    switch (flashType) {
      case 'danger':
        return <span className="material-symbols-outlined state">error</span>;
      case 'success':
        return <span className="material-symbols-outlined state">check_circle</span>;
      default:
        return <span className="material-symbols-outlined state">info</span>;
    }
  })();

  return (
    <div className={`flash flash--${flashType} ${flash ? 'open' : ''}`}>
      <div className="main">
        {icon}
        <p className="message">{flashMessage}</p>
      </div>
      <div onClick={handleClose}>
        <span className="material-symbols-outlined close-icon">close</span>
      </div>
    </div>
  );
};
